// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"8ff4f3f9","166":"633802c3","184":"8d687914","448":"844c5346","495":"58eb10bd","651":"24b2ed5d"}[chunkId] + ".chunk.js";
};